import { api } from '../../../services';

const search = (email: any) => {
    return api.get({
        path: `hiatus/identity-users-manage/user?email=${encodeURIComponent(email)}`
    });
};

export default search;
